// DEPENDENCIES
import React from 'react';

// CORE COMPONENTS
import Form from 'core/form/Form';

// LOCAL COMPONENTS
import Card from 'parts/card/Card';

// LOCAL COMPONENTS
import ReviewChecklist from '../tools/ReviewChecklist';

// FUNCTIONS
const filter = item => !item.spot_instruction_id;

// RENDER
const DealCompletionForm = () => (
  <Form.Body>
    <ReviewChecklist
      name="aryChecklist"
      filter={filter}
    />
  </Form.Body>

)

export default function DealCompletion(props) {
  return <Card title="Deal Completion Checklist" body={<DealCompletionForm {...props} />} />;
}
